export const pricingKeys = {
  all: ["pricing"] as const,
  marketCurrentPtc: (
    market_code: string | undefined,
    revenue_class_code: string | undefined,
  ) =>
    [
      ...pricingKeys.all,
      "marketCurrentPtc",
      market_code,
      revenue_class_code,
    ] as const,

  ptcHistory: (
    market_code: string | undefined,
    revenue_class_code: string | undefined,
  ) =>
    [
      ...pricingKeys.all,
      "ptcHistory",
      market_code,
      revenue_class_code,
    ] as const,
  marketRates: (market_code: string | undefined) =>
    [...pricingKeys.all, "marketRates", market_code] as const,
}
